// Map per-wallet rejection / cancellation / network errors to short
// user-meaningful strings. Without this every cancelled signature
// surfaces as a 300-character RPC dump.

const REJECT_HINTS = [
  /user rejected/i,
  /user denied/i,
  /user closed the/i,
  /request rejected/i,
  /reject the request/i,
  /cancelled/i,
  /actionrejected/i,
];

const NETWORK_HINTS = [
  /network error/i,
  /failed to fetch/i,
  /timeout/i,
  /econnrefused/i,
];

export function friendlyWalletError(e: unknown): string {
  const raw = walletErrorString(e);
  if (REJECT_HINTS.some((p) => p.test(raw))) {
    return "Wallet: signing rejected.";
  }
  if (NETWORK_HINTS.some((p) => p.test(raw))) {
    return `Wallet: network error — ${firstLine(raw)}`;
  }
  // EIP-1193 standard rejection code (MetaMask, Coinbase, …).
  if (typeof e === "object" && e !== null && "code" in e) {
    const code = (e as { code?: unknown }).code;
    if (code === 4001 || code === "ACTION_REJECTED") {
      return "Wallet: signing rejected.";
    }
  }
  // viem BaseError has a `.shortMessage` that's already operator-friendly.
  if (typeof e === "object" && e !== null && "shortMessage" in e) {
    const sm = (e as { shortMessage?: unknown }).shortMessage;
    if (typeof sm === "string" && sm.length > 0) return `Wallet: ${sm}`;
  }
  return `Wallet: ${firstLine(raw)}`;
}

function walletErrorString(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === "string") return e;
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
}

function firstLine(s: string): string {
  const idx = s.indexOf("\n");
  return idx >= 0 ? s.slice(0, idx) : s;
}
